<script setup>
defineProps({
  events: {
    type: Array,
    required: true,
  },
  stages: {
    type: Array,
    default: () => [],
  },
  isLoadingStages: {
    type: Boolean,
    default: false,
  },
  errors: {
    type: Object,
    default: () => ({}),
  },
  onEventChange: {
    type: Function,
    required: true,
  },
});

const eventName = defineModel('eventName', { type: String, required: true });
const dealStageId = defineModel('dealStageId', {
  type: [Number, String],
  default: '',
});
</script>

<template>
  <div class="flex flex-col gap-5">
    <label :class="{ error: errors.event_name }">
      {{ $t('AUTOMATION.ADD.FORM.EVENT.LABEL') }}
      <select v-model="eventName" class="m-0" @change="onEventChange()">
        <option v-for="event in events" :key="event.key" :value="event.key">
          {{ event.value }}
        </option>
      </select>
      <span v-if="errors.event_name" class="message">
        {{ $t('AUTOMATION.ADD.FORM.EVENT.ERROR') }}
      </span>
    </label>

    <section class="flex flex-col gap-2">
      <label :class="{ error: errors.deal_stage_id }">
        {{
          $t(
            eventName === 'contact_created'
              ? 'AUTOMATION.CRM.CONTACT_CREATED.STAGE_LABEL'
              : 'AUTOMATION.CRM.STAGE_ENTERED.STAGE_LABEL'
          )
        }}
        <select
          v-model.number="dealStageId"
          class="m-0"
          :disabled="isLoadingStages"
        >
          <option disabled value="">
            {{
              $t(
                isLoadingStages
                  ? 'AUTOMATION.CRM.STAGES_LOADING'
                  : 'AUTOMATION.CRM.STAGE_PLACEHOLDER'
              )
            }}
          </option>
          <option v-for="stage in stages" :key="stage.id" :value="stage.id">
            {{ stage.name }}
          </option>
        </select>
        <span v-if="errors.deal_stage_id" class="message">
          {{ $t('AUTOMATION.CRM.STAGE_REQUIRED') }}
        </span>
      </label>
      <p class="mb-0 text-sm text-n-slate-10">
        {{
          $t(
            eventName === 'contact_created'
              ? 'AUTOMATION.CRM.CONTACT_CREATED.DESCRIPTION'
              : 'AUTOMATION.CRM.STAGE_ENTERED.DESCRIPTION'
          )
        }}
      </p>
    </section>
  </div>
</template>
